
export interface UsuarioPerfil {
	nombre: string,
	otroNombre: string,
	apellido: string,
	apellidoMaterno: string,
	otroApellido: string,
	documento: string,
	alias: string,
	sexo: string,
	genero: string,
	fechaNacimiento: string,
	edad: string,
	paisNacimiento: string,
	idEmpadronamiento: number,
	isExterno: boolean,
	numeroLegajo?: number
	descripcionPuesto?: string;
    fichaPrivilegiosHexa?: string;
	flags: UsuarioPerfilFlags;
}

export interface UsuarioPerfilFlags {
    errorNumeroLegajo: boolean;
    errorDescPuesto: boolean;
    errorFichaPrivilegios: boolean;
}

export interface UsuarioContacto {
	telefonoCelular: string,
	telefonoParticular: string,
	telefonoInterno: string,
	radio: string,
	correoInstitucional: string,
	correoParticular: string,
	direccion: string,
	codigoPostal: string
}

export interface UsuarioInfoProfesional {
	resena: string,
	resenaMaxChars: number,
	redesSociales: UsuarioRedSocial[]
}

export interface UsuarioRedSocial {
	id: number,
	desc: string,
	nombre: string,
	usuario: string,
	urlPerfil: string
}

export interface RedSocialDisponible {
	id: number,
	desc: string,
	nombre: string,
	baseUrl: string
}

export interface InfoProfesionalError {
	resenaError: InfoProfErrorEnum,
	redesError: InfoProfErrorEnum,
	redesInvalidas: RedSocialInvalida[]
}

export interface RedSocialInvalida {
	id: number,
	nombre: string,
	usuario: string,
	desc: string,
	urlBase: string,
	estado: RedSocialEstadoEnum
}

export interface RedErrorDesc {
	desc: string,
	estado: RedSocialEstadoEnum,
	urlBase: string
}

export enum InfoProfErrorEnum {
	VALIDATION_ERROR = "VALIDATION_ERROR",
	SAVING_ERROR = "SAVING_ERROR",
	NONE = "NONE"
}

export enum RedSocialEstadoEnum {
	ERROR_USUARIO = "ERROR_USUARIO",
	ERROR_URL = "ERROR_URL"
}

export enum InfoProfesionalEstadoEnum {
	VIEWING = "VIEWING",
	EDITING = "EDITING",
	SAVING = "SAVING",
	VISITING = "VISITING",
	ERROR = "ERROR"
}

export interface RedSocialDisponibleUsuario extends RedSocialDisponible {
	usuario?: string,
	urlPerfil?: string
}

export interface RedSocialInput {
	nombre: string,
	usuario: string
}

export interface SaveInfoProfesionalBody {
	resena: string,
	redesSociales: RedSocialInput[]
}

export class TitleConfig {
	title: string;
	prop: string;
	hideIfEmpty?: boolean = false;
	private?: boolean = false;

	constructor( title: string, prop: string, hideIfEmpty: boolean = false, isPrivate: boolean = false ) {
		this.title = title;
		this.prop = prop;
		this.hideIfEmpty = hideIfEmpty;
		this.private = isPrivate;
	}

	public mustShow( data: Object ): boolean {
		return data[this.prop] != null || ( data[this.prop] == null && !this.hideIfEmpty );
	}
}

export const perfilTitles: TitleConfig[] = [
	new TitleConfig( 'Nombre', 'nombre' ),
	new TitleConfig( 'Segundo nombre', 'otroNombre', true ),
	new TitleConfig( 'Apellido', 'apellido' ),
	new TitleConfig( 'Apellido materno', 'apellidoMaterno', true ),
	new TitleConfig( 'Documento', 'documento', false, true ),
	new TitleConfig( 'Sexo biológico', 'sexo' ),
	new TitleConfig( 'Nombre elegido', 'alias', true ),
	new TitleConfig( 'Género', 'genero', true ),
	new TitleConfig( 'Fecha de nacimiento', 'fechaNacimiento', false, true ),
	new TitleConfig( 'Edad', 'edad', false, true ),
	new TitleConfig( 'País de nacimiento', 'paisNacimiento', true ),
	new TitleConfig( 'ID Empadronamiento', 'idEmpadronamiento' ),
	new TitleConfig( 'Legajo Nro.', 'numeroLegajo', true ),
	new TitleConfig( 'Descripción del Puesto', 'descripcionPuesto', true ),
	new TitleConfig( 'Ficha de Privilegios', 'fichaPrivilegiosHexa', true ),
]

export const contactoTitles: TitleConfig[] = [
	new TitleConfig( 'Celular', 'telefonoCelular', false, true ),
	new TitleConfig( 'Teléfono particular', 'telefonoParticular', false, true ),
	new TitleConfig( 'Correo institucional', 'correoInstitucional' ),
	new TitleConfig( 'Correo personal', 'correoParticular', false, true ),
	new TitleConfig( 'Direccion', 'direccion', false, true ),
	new TitleConfig( 'Código postal', 'codigoPostal', false, true )
]
